module.exports = __webpack_public_path__ + "img/14-2.c1ee4c87.png";